export enum featureFlagsNames  {
    eudrGeolocation = 'eudr-geolocation'
}